import { useQuery } from "@tanstack/react-query";
import { api } from "@/services/apiClient";
import { queryKeys } from "@/services/queryClient";
import type { ScenarioDefinitionOut } from "@/services/types";

export function useScenarios() {
  return useQuery<ScenarioDefinitionOut[]>({
    queryKey: queryKeys.scenarios,
    queryFn: () => api.get("/scenarios"),
    staleTime: 60 * 60_000, // static catalog — refresh hourly
  });
}
